import React from "react";
import { observable, toJS } from "mobx";
import {montarSelectOption} from "../../../utils/formatar";
import moment from "moment";

export default class FiltrosCargaGeralAcompanhamentoStore { 

    // Area de inclusão 

    @observable filtroNavio;
    @observable filtros;
    @observable dataInicio;
    @observable dataFim;


    constructor(service) { 
        // Area de inclusão
        this.filtroNavio = false;
        this.dataFim = false;
        this.dataInicio = false;
        this.filtros = {
            placa: null, cpf: null, cnh: null, dataInicio: null, dataFim: null
        };

    }

    onChangeDataInicio = (data) => {

        if(data === null) {
            this.dataInicio = null;
        } else {
            this.dataInicio = moment(data);
        }
        this.dataInicioPesquisa = data;
        this.filtros["dataInicio"] = data;
    };

    
    onChangeDataFim = (data) => {

        if(data === null) {
            this.dataFim = null;
        } else {
            this.dataFim = moment(data);
        }
        this.dataFimPesquisa = data;
        this.filtros["dataFim"] = data;
    };



    onChangeFiltroNavios = value => {
        this.filtroNavio = value!==null ? value : false;
    };

    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/FiltrosCargaGeralAcompanhamentoStore.js